var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[[_c('v-container',{staticClass:"grey lighten-5"},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"8"}},[_c('v-card',{staticClass:"pa-2",attrs:{"outlined":"","tile":""}},[_vm._v(" TEST ")])],1),_c('v-col',{attrs:{"cols":"6","md":"4"}})],1)],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }